export const LEGAL_TERMS_CONDITIONS_LINK = 'https://legal.branch.io/#branchio-ts-cs';
export const LEGAL_PRIVACY_POLICY_LINK = 'https://legal.branch.io/#branchio-privacypolicy';
export const LEGAL_PRIVACY_OPTOUT_LINK = 'https://legal.branch.io/#branchio-privacyoptout';

export const COOKIE_DISPLAY_NAME = 'Cookie Policy';

export const TERMS_CONSENT_DB_FIELD = 'terms_consent_date';

export const COOKIE_ACCEPT_DB_FIELD = 'cookie_accept_date';
export const COOKIE_DECLINE_DB_FIELD = 'cookie_decline_date';
